import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { categories } from "../../../data/categories";
import Container from "../../layout/Container";
import SingleCategory from "./SingleCategory";

const CategoryList = () => {
  useEffect(() => {}, []);
  return (
    <div className="category-list">
      <Container>
        <div className="mt-5 flex flex-row items-end justify-between gap-1">
          <h2 className="font-pop text-2xl font-medium uppercase text-black">
            Popular Categories
          </h2>
          <Link to="/category">
            <span className="mb-[2px] cursor-pointer font-pop text-base  font-bold text-darkGreen underline">
              View more
            </span>
          </Link>
        </div>
        <div className="categories mt-6 flex items-start justify-between gap-2 overflow-x-auto">
          {categories.map((category, index) => (
            <SingleCategory
              key={index}
              name={category.name}
              imageSrc={category.imageSrc}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default CategoryList;
